import React from 'react';
import classNames from 'classnames';

import './ModalUnderlay.scss';

interface ModalUnderlayProps {
  isOpen?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function ModalUnderlay({ isOpen, className, children }: ModalUnderlayProps): React.ReactElement {
  return (
    <div
      className={classNames('underlay', {
        [`${className}__underlay`]: !!className,
        'is-open': isOpen,
        [`${className}__underlay--open`]: !!className && isOpen,
      })}
    >
      {children}
    </div>
  );
}
